import {
  CONTACT_REQUEST,
  CONTACT_SUCCESS,
  CONTACT_FAIL,
} from "../../constants/contactConstants";
import apiClient from "../../lib/apiClient";

export const contact = (contactData) => async (dispatch) => {
  try {
    dispatch({
      type: CONTACT_REQUEST,
    });
    const config = {
      // withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    const { data } = await apiClient.post(
      "/contact",
      contactData,
      config
    );
    dispatch({ type: CONTACT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CONTACT_FAIL,
      payload: error && error.response && error.response.data.message,
    });
  }
};
